export default "__VITE_ASSET__d7cf017c__"